import React from 'react';
import { Chip } from '@mui/material';
import {
    ActivityStatus, ACTIVITY_STATUS_COLORS, ACTIVITY_STATUS_LABELS,
    RiskCriticality, CRITICALITY_COLORS, CRITICALITY_LABELS,
} from '../../../types/execution';

export const StatusChip: React.FC<{ status: ActivityStatus; size?: 'small' | 'medium' }> = ({ status, size = 'small' }) => (
    <Chip
        size={size}
        label={ACTIVITY_STATUS_LABELS[status]}
        sx={{ bgcolor: ACTIVITY_STATUS_COLORS[status], color: '#fff', fontWeight: 500 }}
    />
);

export const CriticalityChip: React.FC<{ criticality: RiskCriticality }> = ({ criticality }) => (
    <Chip
        size="small"
        label={CRITICALITY_LABELS[criticality]}
        sx={{ bgcolor: CRITICALITY_COLORS[criticality], color: '#fff', fontWeight: 500 }}
    />
);

export default StatusChip;
